export default __webpack_public_path__ + "static/media/lockscreen.70508120.jpg";